import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getAwardsScore } from "./awards";
import { getCertificatesScore } from "./certificates";
import { getCustomSectionScore } from "./custom";
import { getLanguagesScore } from "./languages";




export const getNonCoreSectionScore = (resume: ResumeAnalysis, maxNonCoreSectionScore: number) => {

  const certificatesScore = getCertificatesScore(resume.certifications, maxNonCoreSectionScore);
  const awardsScore = resume.awards ? getAwardsScore(resume.awards, maxNonCoreSectionScore) :
    { totalScore: 0, titleScore: 0, issuerScore: 0, descriptionScore: 0 };
  const languagesScore = resume.languages ? getLanguagesScore(resume.languages, maxNonCoreSectionScore) : { totalScore: 0, languageNameScore: 0, proficiencyScore: 0, descriptionScore: 0 };
  const customScore = resume.custom ? getCustomSectionScore(resume.custom, maxNonCoreSectionScore) : { totalScore: 0, descriptionScore: 0 };
  return {
    totalScore: certificatesScore.totalScore + awardsScore.totalScore + languagesScore.totalScore + customScore.totalScore,
    certificatesScore,
    awardsScore,
    languagesScore,
    customScore
  };
}
